import { render } from "./AddProductToPOModal.vue?vue&type=template&id=4a8fbbe3&ts=true"
import script from "./AddProductToPOModal.vue?vue&type=script&lang=ts"
export * from "./AddProductToPOModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__